<template>
  <div id="home">
    welcome
  </div>
</template>
<script>
  import Vue from 'vue';
  export default {
    name: 'Home',
    components: {

    },
    data() {
      return {

      }
    },
    computed: {

    },
    created(){

    },
    methods:{

    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;display: grid;gap: 20px;}
  @media (max-width: 768px) {
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
  }
</style>
